import { render, staticRenderFns } from "./FacilityEditSendSMS.vue?vue&type=template&id=b9c2fa46&"
import script from "./FacilityEditSendSMS.vue?vue&type=script&lang=js&"
export * from "./FacilityEditSendSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports